import * as React from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement>;
export const Input = React.forwardRef<HTMLInputElement, Props>(
  ({ className = "", ...rest }, ref) => (
    <input
      ref={ref}
      className={
        "h-9 w-full rounded-md border bg-white dark:bg-zinc-900 px-3 py-1 text-sm " +
        "border-zinc-300 dark:border-zinc-700 placeholder-zinc-500 outline-none " +
        "focus-visible:ring-2 focus-visible:ring-emerald-500/30 " +
        className
      }
      {...rest}
    />
  )
);
Input.displayName = "Input";
